<script setup lang="ts">
import { inject, ref } from 'vue';
import type { QuizData } from './types/quiz';
import QuizSlide from './components/QuizSlide.vue';
import FinalSection from './components/FinalSection.vue';
import { getXCSRFToken, postQuizAnalytics } from './api';

const quizData = inject<QuizData>('quizData');

const currentQuestion = ref(1);
const totalQuestions = Object.keys(quizData?.questions || {}).length;
const totalScore = ref(0);

let XCSRF_TOKEN = '';

async function addPointsToTotal(id: string, v: number) {
  totalScore.value += v;
  // Get XCSRF token for the next POST request
  if (!XCSRF_TOKEN) {
    await getXCSRFToken()
      .then((r) => (XCSRF_TOKEN = r))
      .catch(() => {});
  }
  if (!XCSRF_TOKEN) return;
  // Send analytics event on selection
  await postQuizAnalytics({
    id: id,
    correct: !!v, // IF 0 -> false ELSE true
  }).catch(() => {});
}
</script>

<template>
  <div>
    <template v-if="quizData && quizData.questions && quizData.questions[1]">
      <QuizSlide
        v-if="quizData.questions[currentQuestion]"
        :question-data="quizData.questions[currentQuestion]"
        :current-question="currentQuestion"
        :total-questions="totalQuestions"
        :is-weighted="quizData.weighted"
        @next-question="currentQuestion++"
        @add-points="addPointsToTotal"
      />
      <FinalSection
        v-else
        :total-score="totalScore"
        :total-questions="totalQuestions"
        :is-weighted="quizData.weighted"
      />
    </template>
    <div
      v-else
      class="p-4 text-center"
    >
      Sorry, this quiz doesn't have any questions
    </div>
  </div>
</template>
